import { Table } from 'redesign';
import { useMemo } from 'react';
import { useGetFlexWorkersColumnDefinition } from '../../../flex-pool-detail/components/flex-workers/hooks/use-get-flex-workers-column-definition';
import { getFlexWorkersTableData } from '../../../flex-pool-detail/components/flex-workers/get-flex-workers-table-data';
import type {
  ColumnDefinition,
  TableDefinition,
} from '../../../flex-pool-detail/components/flex-workers/flex-workers-table.types';
import type { FlexWorkerItem } from '../../../flex-pool-detail/components/flex-workers/flex-workers.types';

type WorkersPoolFlexWorkersTableProps = {
  data: FlexWorkerItem[];
  onShowFlexWorker: (id: string) => void;
  onRemoveFlexWorker: (id: string) => void;
};

export const WorkersPoolFlexWorkersTable = ({
  data,
  onShowFlexWorker,
  onRemoveFlexWorker,
}: WorkersPoolFlexWorkersTableProps) => {
  const columns = useGetFlexWorkersColumnDefinition();
  const tableData = useMemo(() => getFlexWorkersTableData(data), [data]);

  return (
    <Table<ColumnDefinition, TableDefinition>
      stickyHeader
      columns={[
        columns.userProfile,
        columns.name,
        columns.email,
        columns.phone,
        columns.rating,
        columns.deleteAction,
      ]}
      data={tableData}
      onShowFlexWorker={onShowFlexWorker}
      onRemoveFlexWorker={onRemoveFlexWorker}
    />
  );
};
